<a
  class="item"
  [routerLink]="'/' + urlTranslateService.routingTable.shop.listing"
  [queryParams]="queryParams"
>
  {{ name }}
</a>
